export default "__VITE_ASSET__BTRRuu2$__"